import { render } from "./AccountCancelVeritify.vue?vue&type=template&id=00fb162b&scoped=true"
import script from "./AccountCancelVeritify.vue?vue&type=script&lang=js"
export * from "./AccountCancelVeritify.vue?vue&type=script&lang=js"

import "./AccountCancelVeritify.vue?vue&type=style&index=0&id=00fb162b&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fb162b"]])

export default __exports__